import { Component, OnInit } from '@angular/core';
import { SetupService } from '@core/services/setup';

import { DEPARTMENT_TYPE_SENIOR } from 'src/app/core/constants';

@Component({
  selector: 'app-senior-home',
  templateUrl: './senior-home.component.html',
  styleUrls: ['./senior-home.component.scss']
})
export class SeniorHomeComponent implements OnInit {
  /**
   * Definição da identificão da sessão/depto Senior
   */
  public departmentType: string = DEPARTMENT_TYPE_SENIOR;

  constructor(public setupService: SetupService) { }

  ngOnInit(): void {
  }

}
